export const css = {
	root: '_3yBhW3UZ',
	grouphead: '_2Mekw42C',
	actions: '_2SYUszDu',
	group: '_3f_1plOe',
	progress: '_3n51gV3L',
	toc: '_5XKANt6Y',
	resource: '_3RNhp2Qx',
	titleBlock: '_2rp9Z2Bc',
	title: 'ZqAQTspN',
	close: '_1zQRUP7O',
	deck: '_3SAG0VxJ',
	refTitleBlock: '_3JHJ4Eoq',
	complete: '_22PaKnM0',
	incomplete: '_2E4tO9VP',
	refTitle: '_3qKXyulG',
	refTitleAction: '_2tcWKk6X',
	fragment: '_2Z9lLvLA',
	legend: '_1ND4SmgR',
	legendText: '_1J2FRwMY',
	action: '_1VNX-E-u',
	quizblock: '_3bA1wfkE',
	actionIcon: '_1_4aqlUI',
	actionIconFA: 'plWbjOSC',
	actionText: 'Xpy12HVs',
	actionListItem: '_2Z3Zvo4L',
	videolink: '_37ODe1lX',
	cialink: '_2o-Y03Pr',
	activitycontent: '_1q5P-yOS',
	ciacontent: '_3oHJ-aMp',
	resourcecontent: '_1hTCe3pW',
	competencyConnection: '_8wDohiH3',
	resourcelink: '_2SXHZytJ',
	loading: 'QkbNmFCW',
	scorePill: '_6wki6zVn',
	scoreLabel: '_2YT2YMpc',
	lockIcon: '_2gGQfIA7',
	topicBlock: '_2DcbmzEv',
	topicAudio: '_2Y_JcrTN',
	actionBlock: '_3Im4Yhvl',
	' _key': 'book-widgets/topicgroup'
};

export default css;
